import React from 'react';

const CGVPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Conditions Générales de Vente</h1>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Société</h2>
          <p className="text-gray-600">
            Les présentes CGV encadrent les prestations proposées par <strong>MRTP SARL</strong>, 5 Lot. Côte Meunière,
            04370 Villars-Colmars. Toute commande implique l&rsquo;adhésion sans réserve aux présentes clauses.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Offres et devis</h2>
          <p className="text-gray-600">
            Les devis sont valables 30 jours. Ils détaillent les prestations, matériaux, délais estimatifs et modalités
            de règlement. Les modifications demandées par le client donnent lieu à avenant écrit.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Prix et modalités de paiement</h2>
          <p className="text-gray-600">
            Les prix sont exprimés en euros et TTC. Un acompte de 30&nbsp;% est exigé à la commande, le solde étant
            échelonné selon l&rsquo;avancement du chantier. Les paiements s&rsquo;effectuent par virement ou chèque.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Délais</h2>
          <p className="text-gray-600">
            Les délais d&rsquo;exécution sont fournis à titre indicatif. Ils peuvent être ajustés en cas d&rsquo;intempéries,
            de retard administratif ou de force majeure. Dans ces cas, MRTP SARL informe le client par écrit.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Garanties</h2>
          <p className="text-gray-600">
            Nos réalisations bénéficient des garanties légales : parfait achèvement (1 an), garantie biennale (2 ans)
            sur les équipements dissociables, et garantie décennale (10 ans) sur l&rsquo;ouvrage.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Service client</h2>
          <p className="text-gray-600">
            Pour toute question relative aux présentes CGV ou à un chantier en cours, contactez
            <a href="mailto:Contact@artduchalet.com" className="text-[#c4d600] ml-1">Contact@artduchalet.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CGVPage;

